import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { FieldArray, Form, formValueSelector, reduxForm } from 'redux-form';
import { notifyError } from '../../../../../../../helpers/action';
import { propBool, propFunc, propShape, ReduxFormProps, } from '../../../../../../../helpers/custom-prop-types';
import { compose } from '../../../../../../../helpers/recompose';
import { validateShare } from '../../../../../../../validate/custom/slide_search/share';
import ConfirmModal from '../../../../Common/ConfirmModal';
import SlideAddFormTableFieldsArray from './SlideAddFormTableFieldsArray';
import SlideAddFormTableRow from './SlideAddFormTableRow';
const SlideAddFormInner = (props) => {
    const { array, form, handleSubmit, hideModal, invalid, isShowModal, noShareMemberOptionsMessage, onLoadShareMemberOptions, showModal, submit, submitting, } = props;
    const ref = useRef();
    const onChange = useCallback((e) => {
        const fileList = e.currentTarget.files;
        const files = Array.from(fileList);
        if (!files.length) {
            return;
        }
        // ファイルタイプチェック
        const canAllUploadFile = files.every((file) => file.name.match(/\.(pdf|pptx)$/i));
        if (!canAllUploadFile) {
            notifyError('PDFまたはPower Pointの形式のファイルのみ追加いただけます');
            return;
        }
        files.forEach((file) => {
            array.push('slides', {
                blockDownload: false,
                blockShare: false,
                file,
                shareEmail: [],
            });
        });
        e.currentTarget.value = '';
    }, [array]);
    const selector = useMemo(() => formValueSelector(form), [form]);
    const slides = useSelector((state) => selector(state, 'slides'));
    return (_jsxs(_Fragment, { children: [_jsxs(Form, Object.assign({ onSubmit: handleSubmit }, { children: [_jsx("div", Object.assign({ className: 'form_row_file_table' }, { children: _jsx(FieldArray, { component: SlideAddFormTableFieldsArray, form: form, name: 'slides', render: (renderProps) => (_jsx(SlideAddFormTableRow, { fieldName: renderProps.field, form: form, index: renderProps.index, noShareMemberOptionsMessage: noShareMemberOptionsMessage, onClickDelete: renderProps.onClickDelete, onLoadShareMemberOptions: onLoadShareMemberOptions }, renderProps.index)) }) })), _jsx("div", Object.assign({ className: 'form_row_file_add_button' }, { children: _jsxs("label", Object.assign({ className: 'button form_row_file_input_button' }, { children: ["\u8FFD\u52A0\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E\u3059\u308B", _jsx("input", { accept: 'application/pdf,application/vnd.openxmlformats-officedocument.presentationml.presentation', className: 'is-dnone', multiple: true, onChange: onChange, ref: ref, type: 'file' })] })) })), _jsx("div", Object.assign({ className: 'form_row_file_footer' }, { children: _jsx("button", Object.assign({ className: 'button link', disabled: invalid || !slides || slides.length === 0, onClick: showModal, type: 'button' }, { children: "\u30B9\u30E9\u30A4\u30C9\u3092\u30B9\u30C8\u30C3\u30AF\u3059\u308B" })) }))] })), _jsx(ConfirmModal, { body: _jsxs("div", Object.assign({ className: 'modal_body_row description_row' }, { children: [_jsx("div", Object.assign({ className: 'description_label' }, { children: "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3059\u308B\u30D5\u30A1\u30A4\u30EB\u306B\u30D1\u30B9\u30EF\u30FC\u30C9\u306F\u3064\u3044\u3066\u3044\u307E\u305B\u3093\u304B\uFF1F" })), _jsx("div", Object.assign({ className: 'description_label' }, { children: "\u203B\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u3064\u3044\u3066\u3044\u308B\u3068\u3001\u6B63\u5E38\u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3044\u305F\u3060\u3051\u307E\u305B\u3093" }))] })), isShow: isShowModal, onCancel: hideModal, onClick: submit, submitting: submitting, title: 'スライドをストックする' })] }));
};
SlideAddFormInner.propTypes = Object.assign({ noShareMemberOptionsMessage: propFunc().isRequired, onLoadShareMemberOptions: propFunc().isRequired }, ReduxFormProps);
const enhance = compose(reduxForm({
    asyncBlurFields: ['slides[].shareEmail[].email'],
    asyncValidate: validateShare.addForm,
    form: 'SlideAddForm',
}));
const SlideAddForm = enhance(SlideAddFormInner);
SlideAddForm.propTypes = {
    hideModal: propFunc().isRequired,
    isShowModal: propBool().isRequired,
    noShareMemberOptionsMessage: propFunc().isRequired,
    onLoadShareMemberOptions: propFunc().isRequired,
    onSubmit: propFunc().isRequired,
    profile: propShape(),
    showModal: propFunc().isRequired,
    unmountRef: propShape().isRequired,
};
SlideAddForm.defaultProps = {
    profile: {},
};
export default SlideAddForm;
